/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardDetail extends models.ComplianceStandardBase {
    getFixupPrototypeFunction() { return ComplianceStandardDetail.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardDetail>): ComplianceStandardDetail {
        let obj = Object.assign(new ComplianceStandardDetail(), model);
        ComplianceStandardDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardDetail>): ComplianceStandardDetail {
        if (!model) return null;
        return ComplianceStandardDetail.newInstance(<ComplianceStandardDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardDetail) {
        if (!obj) return;

        models.ComplianceStandardDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardDetail): boolean {
        if (models.ComplianceStandardBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceStandardDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.control_action_attributes) {
            for (let key in this.control_action_attributes) {
                let val = this.control_action_attributes[key];
                if (val) {
                    models.ControlFieldAttributes.fixupPrototype(val);
                }
            }
        }
        if (this.control_attributes) {
            for (let key in this.control_attributes) {
                let val = this.control_attributes[key];
                if (val) {
                    models.ControlFieldAttributes.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Tenant ID associated with the standard
     */
    tenant_id: string;

    /**
     * Unique ID for the compliance standard
     */
    compliance_standard_id: string;

    /**
     * Unique URI for the compliance standard
     */
    compliance_standard_uri: string;

    /**
     * Compliance standard number
     */
    compliance_standard_number: string;

    /**
     * Cloud providers this standard applies to (e.g., AWS, Azure, GCP)
     */
    supported_cloud_providers: Array<models.CloudServiceName>;

    /**
     * Creation timestamp
     */
    created_at: Date;

    /**
     * Last update timestamp
     */
    updated_at: Date;

    /**
     * Creator of the standard
     */
    created_by: string;

    /**
     * Last updater of the standard
     */
    updated_by: string;

    /**
     * List of compliance standard versions
     */
    versions: Array<string>;

    /**
     * Dynamic map of action attribute names to their field definitions
     */
    control_action_attributes: { [key: string]: models.ControlFieldAttributes; };

    /**
     * Dynamic map of control attribute names to their field definitions
     */
    control_attributes: { [key: string]: models.ControlFieldAttributes; };

}
